import React from "react";
import classNames from "classnames/bind";
import InputMask from "react-input-mask";

import styles from "./Field.module.css";
import { useStateManager } from "utils/useStateManager";
import { UserType } from "types/UserType";

const cx = classNames.bind(styles);

type Props = {
  label: string;
  value?: string;
  required?: boolean;
  error?: string;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  type?: string;
  disabled?: boolean;
  readOnly?: boolean;
  mask?: string;
  name: string;
};

export const Input: React.FC<Props> = (props) => {
  const {
    label,
    value,
    required,
    error,
    onBlur,
    onFocus,
    type,
    disabled,
    readOnly,
    mask,
    name,
  } = props;
  const { linkInfo, userType } = useStateManager();
  const isEpharmacy = userType === UserType.LITE && linkInfo?.custom?.custom_генерировать_бад_рацион_при_саморегистрации;

  return (
    <label className={cx("field")}>
      {mask ? (
        <InputMask
          className={cx("input", {
            input_filled: !!value,
          })}
          value={value}
          onBlur={onBlur}
          onFocus={onFocus}
          type={type}
          onChange={props.onChange}
          disabled={disabled}
          readOnly={readOnly}
          name={name}
          mask={mask}
        />
      ) : (
        <input
          className={cx("input", {
            input_filled: !!value,
          })}
          value={value}
          onBlur={onBlur}
          onFocus={onFocus}
          type={type}
          onChange={props.onChange}
          disabled={disabled}
          readOnly={readOnly}
          name={name}
        />
      )}

      {label && (
        <span className={cx("label")}>
          {label}
          {required && !isEpharmacy && <span className={cx("required")}>*</span>}
        </span>
      )}

      {error && <span className={cx("error")}>{error}</span>}
    </label>
  );
};
